import { createStore } from 'effector';
import { persist } from 'effector-storage/query';

export const $accessToken = createStore<string | null>(null);

persist({ store: $accessToken, key: 'session' });
